import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from 'react-dom';

import './AutoCompleteTextField.css';
import {AutoCompleteList} from "./AutoCompleteList";
import {remFromPx} from "../../../services/utils/ui-commons";
import getInputSelection, {setCaretPosition} from "../../../services/packages/get-input-selection/getInputSelection";
import getCaretCoordinates from "../../../services/packages/textarea-caret-position/textarea-caret";
import {commonImages} from "../../../assets/images";

const KEY_UP = 38;
const KEY_DOWN = 40;
const KEY_RETURN = 13;
const KEY_ENTER = 14;
const KEY_ESCAPE = 27;

const OPTION_LIST_Y_OFFSET = 10;
const OPTION_LIST_MIN_WIDTH = 100;

const propTypes = {
  Component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  maxOptions: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onRequestOptions: PropTypes.func,
  options: PropTypes.array,
  regex: PropTypes.string,
  matchAny: PropTypes.bool,
  minChars: PropTypes.number,
  requestOnlyIfNoOptions: PropTypes.bool,
  spaceRemovers: PropTypes.array,
  trigger: PropTypes.string,
  value: PropTypes.any,
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
  onRefInput: PropTypes.func,

};


const defaultProps = {
  Component: 'textarea',
  defaultValue: '',
  disabled: false,
  maxOptions: 6,
  onBlur: () => { },
  onChange: (value,key) => { },
  onKeyDown: () => { },
  onRequestOptions: () => { },
  options: [],
  regex: '^[A-Za-z0-9\\-_]+$',
  matchAny: false,
  minChars: 0,
  requestOnlyIfNoOptions: true,
  spaceRemovers: [',', '.', '!', '?'],
  trigger: '@',
  offsetX: 0,
  offsetY: 0,
  onRefInput: () => {}
};


class AutoCompleteArrowDropDown extends React.Component {

    render() {

        const fontSize= this.props.fontSize===undefined ? remFromPx(26) : this.props.fontSize;

        const arrowContainerStyle = {
            height: '100%',
            width: remFromPx(20),
            marginRight: remFromPx(5),
            marginLeft: 'auto',
            marginBottom:remFromPx((fontSize-11)/2),
            display: 'flex',
            flexDirection: 'row',
         //   alignItems: 'flex-end',
            alignSelf: 'center',
        };

        const arrowStyle = {
            width: remFromPx(15),
            height: remFromPx(8)
        };


        const disabled = this.props.disabled===undefined ? false : this.props.disabled;
        const arrowOpenMenuIcon = disabled ? commonImages.dropdown_arrow_gray : commonImages.dropdown_arrow_black;

        const onClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.props.onClick) {
                this.props.onClick(e);
            }
        };

        return (
            <div style={arrowContainerStyle} onClick={onClick}>
                <img style={arrowStyle} src={arrowOpenMenuIcon} alt={''}/>
            </div>
        );
    }
}

/**
 * Input field with autocomplete which is not browser dependant
 */
export class AutocompleteTextField extends React.Component {
    constructor(props) {
        super(props);

        this.isTrigger = this.isTrigger.bind(this);
        this.getMatch = this.getMatch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
        this.updateCaretPosition = this.updateCaretPosition.bind(this);
        this.updateHelper = this.updateHelper.bind(this);
        this.resetHelper = this.resetHelper.bind(this);

        this.state = {
            helperVisible: false,
            left: 0,
            matchLength: 0,
            matchStart: 0,
            options: [],
            selection: 0,
            top: 0,
            value: null,
        };

        this.recentValue = props.defaultValue;
        this.enableSpaceRemovers = false;
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
          if (nextProps.options.length !== this.props.options.length) {
            this.updateHelper(this.recentValue, this.state.caret, nextProps.options);
          }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    getMatch(str, caret, providedOptions) {
        const {trigger, matchAny} = this.props;
        const re = new RegExp(this.props.regex);
        const triggerLength = trigger.length;
        const triggerMatch = trigger.match(re);

        for (let i = caret - 1; i >= 0; --i) {
            const substr = str.substring(i, caret);
            const match = substr.match(re);
            let matchStart = -1;

            if (triggerLength > 0) {
                const triggerIdx = triggerMatch ? i : i - triggerLength + 1;

                if (triggerIdx < 0) { // out of input
                    return null;
                }

                if (this.isTrigger(str, triggerIdx)) {
                    matchStart = triggerIdx + triggerLength;
                }

                if (!match && matchStart < 0) {
                    return null;
                }
            } else {
                if (match && i > 0) { // find first non-matching character or begin of input
                    continue;
                }
                matchStart = i === 0 && match ? 0 : i + 1;

                if (caret - matchStart === 0) { // matched slug is empty
                    return null;
                }
            }

            if (matchStart >= 0) {
                const matchedSlug = str.substring(matchStart, caret);
                const matchedSlugNoAccent = matchedSlug.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                const options = providedOptions.filter((slug) => {
                    const slugNoAccent = slug.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    const idx = slugNoAccent.toLowerCase().indexOf(matchedSlugNoAccent);
                    return idx !== -1 && (matchAny || idx === 0);
                });

                const matchLength = matchedSlugNoAccent.length;

                return {matchStart, matchLength, options};
            }
        }

        return null;
    }

    isTrigger(str, i) {
        const {trigger} = this.props;

        if (!trigger || !trigger.length) {
            return true;
        }

        if (str.substr(i, trigger.length) === trigger) {
            return true;
        }

        return false;
    }

    handleChange(e) {
        const {onChange, options, spaceRemovers} = this.props;

        const old = this.recentValue;
        const str = e.target.value;
        const caret = getInputSelection(e.target).end;

        if (!str.length) {
            this.setState({helperVisible: false});
        }


        this.recentValue = str;

        this.setState({caret, value: e.target.value});

        let key = e.target.key;
        if (key===undefined) {
            const option = options.find(value => value.toUpperCase() === str.toUpperCase());
            if (option!==undefined) {
                key=option.key;
            }
        }

        if (!str.length || !caret) {
              return onChange(e.target.value,key);
        }

        // '@wonderjenny ,|' -> '@wonderjenny, |'
        if (this.enableSpaceRemovers && spaceRemovers.length && str.length > 2) {
            for (let i = 0; i < Math.max(old.length, str.length); ++i) {
                if (old[i] !== str[i]) {
                    if (
                        i >= 2 &&
                        str[i - 1] === ' ' &&
                        spaceRemovers.indexOf(str[i - 2]) === -1 &&
                        spaceRemovers.indexOf(str[i]) !== -1 &&
                        this.getMatch(str.substring(0, i - 2).toLowerCase(), caret - 3, options)
                    ) {
                        const newValue = (`${str.slice(0, i - 1)}${str.slice(i, i + 1)}${str.slice(i - 1, i)}${str.slice(i + 1)}`);

                        this.updateCaretPosition(i + 1);
                        findDOMNode(this.refInput).value = newValue;

                        if (!this.props.value) {
                            this.setState({value: newValue});
                        }

                        let key = e.target.key;
                        if (key===undefined) {
                            const option = options.find(value => value.toUpperCase() === newValue.toUpperCase());
                            if (option!==undefined) {
                                key=option.key;
                            }
                        }


                        return onChange(newValue,key);
                    }

                    break;
                }
            }

            this.enableSpaceRemovers = false;
        }

        this.updateHelper(str, caret, options);

        if (!this.props.value) {
            this.setState({value: e.target.value});
        }

        return onChange(e.target.value,key);
    }

    handleKeyDown(event) {
        if (this.state.helperVisible) {
            const {options, selection} = this.state;

            switch (event.keyCode) {
                case KEY_ESCAPE:
                    event.preventDefault();
                    this.resetHelper();
                    break;
                case KEY_UP:
                    event.preventDefault();
                    this.setState({selection: ((options.length + selection) - 1) % options.length});
                    break;
                case KEY_DOWN:
                    event.preventDefault();
                    this.setState({selection: (selection + 1) % options.length});
                    break;
                case KEY_ENTER:
                case KEY_RETURN:
                    event.preventDefault();
                    this.handleSelection(selection);
                    break;
                default:
                    this.props.onKeyDown(event);
                    break;
            }
        } else {
            this.props.onKeyDown(event);
        }
    }

    handleResize() {
        this.setState({helperVisible: false});
    }

    handleSelection(idx) {
        const {matchStart, matchLength, options} = this.state;

        const slug = options[idx].value;
        const key = options[idx].key;
        const value = this.recentValue;
        const part1 = value.substring(0, matchStart);
        const part2 = value.substring(matchStart + matchLength);

        const event = {target: findDOMNode(this.refInput)};

       // event.target.value = `${part1}${slug}${part2}`;
        event.target.value = `${slug}`;
        event.target.key = `${slug}`;
        this.handleChange(event);

        this.resetHelper();

        this.updateCaretPosition(part1.length + slug.length + 1);

        this.enableSpaceRemovers = true;
    }

    updateCaretPosition(caret) {
        this.setState({caret}, () => setCaretPosition(findDOMNode(this.refInput), caret));
    }

    updateHelper(str, caret, options) {
        const input = findDOMNode(this.refInput);


        const slug = this.getMatch(str.toLowerCase(), caret, options);

        if (slug) {
            const caretPos = getCaretCoordinates(input, caret);
            const rect = input.getBoundingClientRect();

            const top = caretPos.top + input.offsetTop;
            const left = Math.min(
                caretPos.left + input.offsetLeft - OPTION_LIST_Y_OFFSET,
                input.offsetLeft + rect.width - OPTION_LIST_MIN_WIDTH
            );

            if (
                slug.matchLength >= this.props.minChars &&
                (slug.options.length > 1 || (slug.options.length === 1 && slug.options[0].value.length !== slug.matchLength))) {
                 this.setState({helperVisible: true, top, left, ...slug});
            } else {
                 if (!this.props.requestOnlyIfNoOptions || !slug.options.length) {
                    this.props.onRequestOptions(str.substr(slug.matchStart, slug.matchLength));
                }

                this.resetHelper();
            }
        } else {
            this.resetHelper();
        }
    }

    resetHelper() {
        const resetData = {
            helperVisible: false,
            selection: 0,
            left: 0,
            matchLength: 0,
            matchStart: 0,
            options: [],
            top: 0,
          //  value: null
        };
       //     this.setState({helperVisible: false, selection: 0});
        this.setState(resetData);
    }

    /* eslint-enable jsx-a11y/no-static-element-interactions */

    render() {
        const {Component, defaultValue, disabled, value,fontSize,showArrowDropDown, ...rest} = this.props;


        const propagated = Object.assign({}, rest);
     /*
        Object.keys(this.constructor.propTypes).forEach((k) => {
            delete propagated[k];
        });
*/
        Object.keys(propTypes).forEach((k) => {
            delete propagated[k];
        });

        let val = '';

        if (typeof value !== 'undefined' && value !== null) {
            val = value;
        } else if (this.state.value) {
            val = this.state.value;
        } else if (defaultValue) {
            val = defaultValue;
        }

        if (this.state.selection>this.state.options.length) {
            this.setState({selection: 0});
        }

        const containerStyle = {
            width:'100%',
            display:'flex',
        };

        const arrowOnClick = (e) => {

            if (this.state.options.length===0) {
                const options = this.props.options;
                const input = findDOMNode(this.refInput);
                const caretPos = getCaretCoordinates(input, this.state.caret);
                const rect = input.getBoundingClientRect();

                const top = caretPos.top + input.offsetTop;
                const left = Math.min(
                    caretPos.left + input.offsetLeft - OPTION_LIST_Y_OFFSET,
                    input.offsetLeft + rect.width - OPTION_LIST_MIN_WIDTH
                );

                const helperVisible = !this.state.helperVisible;

                const state = {...this.state, helperVisible, options, left, top};
                this.setState(state);
            }
            else {
                const helperVisible = !this.state.helperVisible;

                const state = {...this.state, helperVisible};
                this.setState(state);

            }
        };

         return (
            <span>
                <div style={containerStyle}>
                    <Component
                        disabled={disabled}
                        onBlur={this.props.onBlur}
                        onChange={this.handleChange}
                        onKeyDown={this.handleKeyDown}
                        ref={(c) => {
                            this.refInput = c;
                            this.props.onRefInput(c);
                        }}
                        value={val}
                        {...propagated}/>
                    {showArrowDropDown ?
                        <AutoCompleteArrowDropDown disabled={disabled} fontSize={fontSize} onClick={arrowOnClick}/>
                        : ''
                    }
                </div>
          <AutoCompleteList helperVisible={this.state.helperVisible }
                            displayProps={this.props}
                            valueProps={this.state}
                            onClickLine = { (idx) =>  this.handleSelection(idx) }
                            onEnterLine = { (idx) =>  this.setState({selection: idx}) }
          />
      </span>
        );
    }
}

AutocompleteTextField.propTypes = propTypes;
AutocompleteTextField.defaultProps = defaultProps;

export default AutocompleteTextField;
